import axios from 'axios';
import { useInfiniteQuery } from 'react-query';

import { LeaderboardResultPage } from '~/../api/common.types';
import { FILTERS } from '~/constants';

export const useGetRankings = ({ enabled, filters, page }) => {
  // TODO: convert this to a POST...
  const characters = filters[FILTERS.characters];
  let levels = filters[FILTERS.levels];
  let dead = false;
  if (levels && levels.includes('dead')) {
    levels = levels.filter((level) => level !== 'dead');
    dead = true;
  }
  const syndicates = filters[FILTERS.syndicates];
  const types = filters[FILTERS.types];
  const hps = filters[FILTERS.hps];
  const owned = filters[FILTERS.owned];

  const isContext = filters[FILTERS.context];
  return useInfiniteQuery<LeaderboardResultPage | undefined, Error>(
    [
      'rankings',
      characters,
      levels,
      syndicates,
      types,
      hps,
      owned,
      dead,
      isContext,
      page,
    ],
    async ({ pageParam }) => {
      const url = `/api/rankings?page=${
        pageParam || page
      }&levels=${levels}&characters=${encodeURIComponent(
        characters
      )}&syndicates=${encodeURIComponent(
        syndicates
      )}&types=${encodeURIComponent(types)}&hps=${encodeURIComponent(
        hps
      )}&owned=${encodeURIComponent(
        owned
      )}&dead=${dead}&isContext=${isContext}`;
      const { data } = await axios({
        url,
        method: 'get',
      });
      return data;
    },
    {
      enabled: enabled,
      staleTime: 60 * 1000 * 5,
      keepPreviousData: true,
      getNextPageParam: () => {
        return page + 1;
      },
      getPreviousPageParam: () => {
        return page - 1;
      },
    }
  );
};
